import React from 'react';
import { ArchiveIcon, Button, Checkbox, Strong, Table } from 'evergreen-ui';
import { NotifyDialog } from 'Shared/Notifications/NotifyDialog';
import { SimplePaginate } from 'Shared/SimplePaginate';
import { useVirtualListTableStyles } from 'styles/useStyles';

/**
 * Компонент для уведомлений
 *
 *
 * @param checkedAll
 * @param onCheckedAll
 * @returns {JSX.Element}
 * @constructor
 */
const NotifyTable = ({
  children,
  checked,
  onCheckedAll,
  thead,
  onClickedButton,
  disabledButton,
  disabledCheckBox,
  isShownDialog,
  dialogData,
  closeDialog,
  multiple,
  onConfirmDialogData,
  isConfirmDisabled,
  currentPage,
  onPageChange,
  totalPages,
}) => {
  const tableClasses = useVirtualListTableStyles();

  return (
    <>

      <div className={tableClasses.tableWrapper}>
        <Table>
          <Table.Head minHeight={40}>
            <Table.HeaderCell flex="0 0 0">
              <Checkbox
                checked={checked}
                onChange={onCheckedAll}
                disabled={disabledCheckBox}
              />
            </Table.HeaderCell>
            {
              thead.map((th) => (
                React.Children.toArray(<Table.HeaderCell style={th.cellProps}><Strong>{th.name}</Strong></Table.HeaderCell>)
              ))
            }
            <Table.HeaderCell flexBasis={250} flexShrink={0} flexGrow={0}>
              <Button
                iconBefore={ArchiveIcon}
                appearance="minimal"
                intent="danger"
                onClick={onClickedButton}
                disabled={disabledButton}
              >
                Отметить прочитанными
              </Button>
            </Table.HeaderCell>
          </Table.Head>
        </Table>
        {children}
      </div>
      { isShownDialog
        && (
          <NotifyDialog
            data={dialogData}
            closeDialog={closeDialog}
            multiple={multiple}
            onConfirm={onConfirmDialogData}
            isConfirmDisabled={isConfirmDisabled}
          />
        )}
      <SimplePaginate
        currentPage={currentPage}
        onPageChange={onPageChange}
        totalPages={totalPages}
      />
    </>
  );
};

export default NotifyTable;
